module.exports = __webpack_public_path__ + "f6038e15def9af9c027fd6c3b0714c4b.svg";